export const getParamsFromReferrer = () => {
  const { referrer } = document;
  const queryParams = referrer?.split('?')[1];
  const paramsArray = queryParams?.split('&');
  const keyPar = paramsArray?.reduce((acc, val) => {
    const [key, value] = val?.split('=');
    return { ...acc, [key]: value };
  }, {});

  return keyPar;
};

export const getAffParam = () => {
  const keyPar = getParamsFromReferrer();
  return keyPar?.aff;
};

export const getCJeventParam = () => {
  const keyPar = getParamsFromReferrer();
  return keyPar?.cjevent;
};

export const getPromotionParam = () => {
  const keyPar = getParamsFromReferrer();
  return keyPar?.p;
};

export const getOfferCodeParam = () => {
  const keyPar = getParamsFromReferrer();
  return keyPar?.offer;
};
